import type { ActivityTemplate } from '../types/activityTracking';

/**
 * Default suggested activities based on common 12-step recovery practice.
 * Seeded for new users. Auto-tracked items are pre-populated from app data.
 * Users can add, remove, or reorder any of these.
 */
export const SUGGESTED_ACTIVITIES: ActivityTemplate[] = [
  // Auto-tracked (populated from existing check-in data — user cannot manually tap)
  {
    name: 'Morning Check-In',
    category: 'recovery',
    targetFrequency: 7,
    isAutoTracked: true,
    autoTrackSource: 'morning_checkin',
  },
  {
    name: 'Nightly Review',
    category: 'recovery',
    targetFrequency: 7,
    isAutoTracked: true,
    autoTrackSource: 'nightly_review',
  },
  // Manual activities
  { name: 'Attended a meeting',                category: 'recovery',  targetFrequency: 3, isAutoTracked: false },
  { name: 'Called sponsor',                    category: 'recovery',  targetFrequency: 3, isAutoTracked: false },
  { name: 'Called another person in recovery', category: 'recovery',  targetFrequency: 2, isAutoTracked: false },
  { name: 'Prayer / meditation',               category: 'spiritual', targetFrequency: 7, isAutoTracked: false },
  { name: 'Step work',                         category: 'recovery',  targetFrequency: 3, isAutoTracked: false },
  { name: 'Read recovery literature',          category: 'spiritual', targetFrequency: 7, isAutoTracked: false },
  { name: 'Gratitude list',                    category: 'spiritual', targetFrequency: 7, isAutoTracked: false },
  { name: 'Service work',                      category: 'service',   targetFrequency: 1, isAutoTracked: false },
  { name: 'Exercise / self-care',              category: 'physical',  targetFrequency: 3, isAutoTracked: false },
  { name: 'Journal entry',                     category: 'spiritual', targetFrequency: 3, isAutoTracked: false },
  { name: 'Talked through feelings with someone', category: 'emotional', targetFrequency: 3, isAutoTracked: false },
  { name: 'Practiced self-compassion',            category: 'emotional', targetFrequency: 3, isAutoTracked: false },
  { name: 'Named and wrote down my emotions',     category: 'emotional', targetFrequency: 3, isAutoTracked: false },
];

export const CATEGORY_LABELS: Record<string, string> = {
  recovery:  'Recovery',
  spiritual: 'Spiritual',
  physical:  'Physical',
  emotional: 'Emotional',
  service:   'Service',
  custom:    'Custom',
};

export const DEFAULT_CATEGORY_ORDER = ['recovery', 'spiritual', 'physical', 'emotional', 'service', 'custom'] as const;

/** Human-readable frequency labels */
export function frequencyLabel(n: number): string {
  if (n === 7) return 'Daily';
  if (n === 1) return '1×/week';
  return `${n}×/week`;
}
